import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Modal from 'components/ui/Modal';
import { TimeoutResult } from 'types/common';
import socketSlice from 'modules/sockets/reducer';

import { b } from 'utils/i18nUtils';

import { Icon } from 'components/ui';
import terminalImage from 'assets/images/terminal.jpg';

interface Props {
  open: boolean;
  isPaid: boolean;
}
const KioskInstructionModal: React.FC<Props> = ({ open = false, isPaid }) => {
  const dispatch = useDispatch();
  const ref = React.useRef(null); // Empty reference for the focus

  const timeoutRef = React.useRef<TimeoutResult>(null);
  React.useLayoutEffect(() => {
    if (isPaid) {
      timeoutRef.current = setTimeout(() => {
        dispatch(socketSlice.actions.closeInstructionModal());
      }, 3500);
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [isPaid]);

  return (
    <Modal focusRef={ref} open={open} className="modal-large">
      <div
        data-testid="pending-payment-warning-modal"
        className="flex flex-col items-center mt-5 kiosk:my-36 text-center"
      >
        {!isPaid && (
          <>
            <FormattedMessage
              id="page.finalInvoice.modal.kioskInstruction.proceedTitle"
              defaultMessage="Proceed to payment"
              tagName="h2"
            />
            <div className="kiosk:min-h-155 grid place-items-center kiosk:my-14">
              <img src={terminalImage} alt="Payment terminal" />
            </div>
            <FormattedMessage
              id="page.finalInvoice.modal.kioskInstruction.proceedContent"
              defaultMessage="Please <b>follow the payment instructions</b> displayed on the <b>terminal</b> to the right of this screen."
              tagName="p"
              values={{ b }}
            />
          </>
        )}

        {isPaid && (
          <>
            <FormattedMessage
              id="page.finalInvoice.modal.kioskInstruction.paidTitle"
              defaultMessage="Payment complete"
              tagName="h2"
            />
            <div
              className="w-[586px] h-[586px] grid place-items-center
              bg-success-lowest rounded-full kiosk:my-20"
            >
              <div className="rounded-full size-52 bg-success-default ring-36 ring-success-default flex items-center justify-center">
                <Icon className="fb-icon--check text-9xl kiosk:text-9xl text-white"/>
              </div>
            </div>
            <FormattedMessage
              id="page.finalInvoice.modal.kioskInstruction.paidContent"
              defaultMessage="Thank you for <b>your payment!</b>"
              tagName="p"
              values={{ b }}
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default KioskInstructionModal;
